module.exports = __webpack_public_path__ + "img/桌球賽事影像分析.fe5fbd05.jpg";